<template>
  <div v-if="show" class="subscription-loader-overlay">
    <div class="subscription-loader-spinner">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionLoader',

  props: {
    /**
     * Whether to show the loading overlay
     */
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
/* Styles to /assets/scss/components/pricing.scss */
</style>
